import { render, staticRenderFns } from "./accepts.vue?vue&type=template&id=4da30db8"
import script from "./accepts.vue?vue&type=script&lang=js"
export * from "./accepts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports